import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1cffcfd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trust-data-practices" }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Maintain trust data", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Practices", -1))
const _hoisted_5 = { class: "search" }
const _hoisted_6 = { class: "search-inputs" }
const _hoisted_7 = { class: "search-bar" }
const _hoisted_8 = { class: "icon-hm" }
const _hoisted_9 = {
  key: 0,
  class: "fal fa-spinner fa-spin fa-lg"
}
const _hoisted_10 = {
  key: 1,
  class: "fal fa-search fa-lg"
}
const _hoisted_11 = {
  class: "bottom-half",
  style: {"width":"100%","overflow":"auto"}
}
const _hoisted_12 = { class: "ls-table practice-table" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["colspan"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = ["colspan"]
const _hoisted_23 = ["title"]
const _hoisted_24 = { "data-label": "Practice - Branch ID" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { "data-label": "Practice status" }
const _hoisted_27 = { "data-label": "Trust account status" }

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Search name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.search) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search]
            ]),
            _createElementVNode("span", _hoisted_8, [
              (_ctx.isSearching)
                ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                : (_openBlock(), _createElementBlock("i", _hoisted_10))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("table", _hoisted_12, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
              return (_openBlock(), _createElementBlock("th", {
                class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(h.text), 1),
                  (h.sortable)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', h.sortMethod])
                      }, _hoisted_16, 2))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_13))
            }), 256))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_ctx.loadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_LoadingIndicator)
                ], 8, _hoisted_18)
              ]))
            : (_ctx.errorLoadingContent)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, [
                    _createVNode(_component_ErrorIndicator)
                  ], 8, _hoisted_20)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practices.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _createElementVNode("td", {
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_22)
                  ]))
                : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.practices.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.practices, (p) => {
                      return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", {
                          "data-label": "Practice (Trading name)",
                          title: p.branchId == null ? p.name : p.name + ' - ' + p.tradingName
                        }, [
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.RouteN.TA.Practice.n, query: { pId: p.id } },
                            class: "link"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(p.branchId == null ? p.name : p.name + ' - ' + p.tradingName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ], 8, _hoisted_23),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(p.branchId == null ? p.firmId : p.firmId + ' - ' + p.branchId), 1),
                        _createElementVNode("td", {
                          "data-label": "Branch address",
                          title: p.address
                        }, _toDisplayString(p.address ?? ''), 9, _hoisted_25),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(p.statusDescription ?? ''), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(p.trustAccountStatus?.name ?? ''), 1)
                      ]))
                    }), 256))
                  : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}